'use client'

// src/Webview/Unload.tsx
import { useEffect } from "react";
import { useDeviceDetect } from "@wbk/hooks";
var WebviewUnload = ({ loading }) => {
  const { isWebView } = useDeviceDetect();
  useEffect(() => {
    var _a;
    if (isWebView && !loading) {
      (_a = window.ReactNativeWebView) == null ? void 0 : _a.postMessage(
        JSON.stringify({
          eventName: "UNLOAD_WEBVIEW"
        })
      );
    }
  }, [isWebView, loading]);
  return null;
};
var Unload_default = WebviewUnload;

export {
  Unload_default
};
//# sourceMappingURL=chunk-EM7K22S3.mjs.map